import { affiliate } from "./affiliate";
import { billingInfo } from "./billingInfo";

export const communityMembers = {
  affiliate,
  billingInfo,
};
